import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type DropdownType = {
  [key: string]: object[]
}

type DropdownStore = {
  dropdowns: DropdownType
  setDropdowns: (key: string, permissions: object[]) => void
  clear: () => void
}

export const useDropdownStore = create<DropdownStore>()(
  persist(
    (set) => ({
      dropdowns: {},
      clear: () => set({ dropdowns: {} }),
      setDropdowns: (key: string, dropdownList: object[]) =>
        set((state) => ({
          dropdowns: { ...state.dropdowns, [key]: dropdownList },
        })),
    }),
    {
      name: 'dropdown-storage',
      storage: encryptedStorage(),
    }
  )
)
